import React, { useState } from 'react';
import { DownloadIcon } from 'lucide-react';
import { MetricCard } from '../components/MetricCard';
import { BarChart } from '../components/charts/BarChart';
import { PieChart } from '../components/charts/PieChart';
import { DateSelector } from '../components/DateSelector';
export const UserInsights: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const timeRanges = ['12 months', '3 months', '30 days', '7 days', 'Today'];
  const peakUsageData = [{
    period: 'Morning (6am-12pm)',
    percentage: 32
  }, {
    period: 'Afternoon (12pm-5pm)',
    percentage: 41
  }, {
    period: 'Evening (5pm-10pm)',
    percentage: 24
  }, {
    period: 'Night (10pm-6am)',
    percentage: 3
  }];
  const deviceUsageData = [{
    name: 'Mobile',
    value: 63
  }, {
    name: 'Desktop',
    value: 29
  }, {
    name: 'Tablet',
    value: 8
  }];
  const ageData = [{
    age: '18-24',
    percentage: 12
  }, {
    age: '25-34',
    percentage: 28
  }, {
    age: '35-44',
    percentage: 24
  }, {
    age: '45-54',
    percentage: 19
  }, {
    age: '55-64',
    percentage: 11
  }, {
    age: '65+',
    percentage: 6
  }];
  const genderData = [{
    name: 'Female',
    value: 51
  }, {
    name: 'Male',
    value: 49
  }];
  return <div data-id="element-602">
      <div className="flex justify-between items-center mb-6" data-id="element-603">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-604">User Insights</h2>
        <button className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-md text-sm" data-id="element-605">
          <DownloadIcon size={16} className="mr-2" data-id="element-606" />
          Download report
        </button>
      </div>
      <div className="mb-6" data-id="element-607">
        <div className="flex space-x-4 mb-6" data-id="element-608">
          {timeRanges.map(range => <button key={range} className={`px-4 py-2 text-sm rounded-md ${range === '30 days' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-609">
              {range}
            </button>)}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-610">
        <MetricCard title="Total Users" value="245,918" change={{
        value: '+8.3%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-612">
              Download report
            </a>} data-id="element-611" />
        <MetricCard title="Active Users" value="178,345" change={{
        value: '+12.1%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-614">
              Download report
            </a>} data-id="element-613" />
        <MetricCard title="Geographic Reach" value="94%" change={{
        value: '+122.74',
        positive: true,
        prefix: '+'
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-616">
              Download report
            </a>} data-id="element-615" />
        <MetricCard title="Journey Completion" value="76.4%" change={{
        value: '-0.5%',
        positive: false
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-618">
              Download report
            </a>} data-id="element-617" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-619">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-620">
          <div className="flex justify-between items-center mb-6" data-id="element-621">
            <h3 className="text-lg font-medium" data-id="element-622">Peak Usage Periods</h3>
            <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-623" />
          </div>
          <BarChart data={peakUsageData} nameKey="period" dataKey="percentage" horizontal={true} data-id="element-624" />
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-625">
          <div className="flex justify-between items-center mb-6" data-id="element-626">
            <div data-id="element-627">
              <h3 className="text-lg font-medium" data-id="element-628">Device Usage</h3>
              <p className="text-sm text-gray-500" data-id="element-629">
                Platform analytics and session data
              </p>
            </div>
            <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-630" />
          </div>
          <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-631">
            {deviceUsageData.map(device => <div key={device.name} className="text-center" data-id="element-632">
                <div className="flex items-center justify-center mb-2" data-id="element-633">
                  <div className={`w-3 h-3 rounded-full mr-2 ${device.name === 'Mobile' ? 'bg-blue-600' : device.name === 'Desktop' ? 'bg-blue-400' : 'bg-blue-200'}`} data-id="element-634"></div>
                  <span className="text-sm" data-id="element-635">{device.name}</span>
                </div>
                <p className="text-2xl font-semibold" data-id="element-636">{device.value}%</p>
              </div>)}
          </div>
          <PieChart data={deviceUsageData} nameKey="name" dataKey="value" colors={['#2563eb', '#60a5fa', '#93c5fd']} data-id="element-637" />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-638">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-639">
          <div className="flex justify-between items-center mb-6" data-id="element-640">
            <div data-id="element-641">
              <h3 className="text-lg font-medium" data-id="element-642">User Demographics</h3>
              <p className="text-sm text-gray-500" data-id="element-643">Age composition</p>
            </div>
            <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-644" />
          </div>
          <BarChart data={ageData} nameKey="age" dataKey="percentage" horizontal={true} data-id="element-645" />
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-646">
          <div className="flex justify-between items-center mb-6" data-id="element-647">
            <div data-id="element-648">
              <h3 className="text-lg font-medium" data-id="element-649">User Demographics</h3>
              <p className="text-sm text-gray-500" data-id="element-650">Gender composition</p>
            </div>
            <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-651" />
          </div>
          <div className="flex justify-center" data-id="element-652">
            <PieChart data={genderData} nameKey="name" dataKey="value" colors={['#2563eb', '#60a5fa']} data-id="element-653" />
          </div>
          <div className="flex justify-center mt-4" data-id="element-654">
            <div className="text-center" data-id="element-655">
              <p className="text-lg font-semibold" data-id="element-656">Total Users</p>
              <p className="text-3xl font-bold" data-id="element-657">245,918</p>
              <div className="flex justify-center space-x-8 mt-4" data-id="element-658">
                <div data-id="element-659">
                  <p className="text-gray-600" data-id="element-660">Female</p>
                  <p className="text-xl font-semibold" data-id="element-661">51%</p>
                </div>
                <div data-id="element-662">
                  <p className="text-gray-600" data-id="element-663">Male</p>
                  <p className="text-xl font-semibold" data-id="element-664">49%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};